import { render } from "./TranslateInput.vue?vue&type=template&id=7ccf46c1"
import script from "./TranslateInput.vue?vue&type=script&lang=js"
export * from "./TranslateInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__